import http from '@/utils/http'
import { LOCAL_STORAGE_KEYS } from '@/constants'

const initialState = () => ({
  list: JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.CUSTOMER_LIST)) || [],
  customer: JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.CUSTOMER)) || {}
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.CUSTOMER)
    localStorage.removeItem(LOCAL_STORAGE_KEYS.CUSTOMER_LIST)

    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LIST (state, list) {
    state.list = list
    localStorage.setItem(LOCAL_STORAGE_KEYS.CUSTOMER_LIST, JSON.stringify(list))
  },
  SET_CUSTOMER (state, customer = {}) {
    state.customer = customer

    localStorage.setItem(LOCAL_STORAGE_KEYS.CUSTOMER, JSON.stringify(customer))
  }
}

export const getters = {
  list: state => state.list,
  customer: state => state.customer,
  customerGuid: state => state.customer.CustomerGuid,
  name: state => state.customer.Name
}

export const actions = {
  async fetchCustomers ({ getters, commit, rootGetters }) {
    if (getters.list.length) {
      return getters.list
    }
    try {
      const customers = await http({
        url: `${process.env.VUE_APP_API_URL}customerjobsstatus/${rootGetters['auth/token']}`
      }) || []

      if (customers.length === 1 && customers[0]) {
        commit('SET_CUSTOMER', customers[0])
      }
      commit('SET_LIST', customers)

      return customers
    } catch (e) {
      return []
    }
  }
}
